import { CaretRightOutlined } from '@ant-design/icons';
import { Button, Checkbox, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { canvasSelector, setFilterList } from '../../../redux/canvas/reducer';
import { BUILT_IN_COMPONENT } from '../../../store/mockyData';
import Element from '../../Element';
import './styles.scss';

const FilterComponentModal = ({ visible = false, componentObj, onClose = () => {} }) => {
  const dispatch = useDispatch();

  const categories = BUILT_IN_COMPONENT[componentObj.componentType];
  const { filterList } = useSelector(canvasSelector);

  const [dropdown, setDropdown] = useState(true);
  const [filter, setFilter] = useState(filterList);
  const [chosenCategory, setChosenCategory] = useState();
  const [chosenSubCategory, setChosenSubCategory] = useState();

  const choseCategory = (cate) => {
    if (cate !== chosenCategory) {
      setDropdown(false);
    } else {
      setDropdown(!dropdown);
    }
    if (chosenSubCategory) setChosenSubCategory(null);
    setChosenCategory(cate);
  };

  const choseSubCategory = (cate) => {
    setChosenSubCategory(cate);
  };

  const onSave = async () => {
    dispatch(setFilterList(filter));
    onClose();
  };

  const filterItem = (category, subCategory) => {
    const refineList = new Set(filter.map((i) => i.groupId || i));

    if (subCategory) {
      const isSubCategoryFiltered = refineList.has(subCategory.groupId);

      if (isSubCategoryFiltered) {
        // Discard subCategory
        refineList.delete(subCategory.groupId);

        // If all subCategories have been checked, discard the category from the filter list
        const isAllSubCategoriesChosen = [...refineList].some((item) => item.startsWith(category.groupId));
        if (isAllSubCategoriesChosen) {
          refineList.delete(category.groupId);
        }
      } else {
        // Uncheck subCategory
        refineList.add(subCategory.groupId);

        // Check if all subCategories are filtered
        const isAllSubCategoriesFiltered = category.subCategoryList.every((subCat) => refineList.has(subCat.groupId));

        if (isAllSubCategoriesFiltered) {
          refineList.add(category.groupId);
        }
      }
    } else {
      const isCategoryFiltered = refineList.has(category.groupId);
      const hasSubCategories = category.subCategoryList && category.subCategoryList.length > 0;

      if (isCategoryFiltered) {
        // Uncheck all
        refineList.delete(category.groupId);

        if (hasSubCategories) {
          category.subCategoryList.forEach((subCat) => {
            refineList.delete(subCat.groupId);
          });
        }
      } else {
        // Check all
        refineList.add(category.groupId);

        if (hasSubCategories) {
          category.subCategoryList.forEach((subCat) => {
            if (!refineList.has(subCat.groupId)) {
              refineList.add(subCat.groupId);
            }
          });
        }
      }
    }

    setFilter([...refineList]);
  };

  const renderCategory = (i) =>
    i.map((cate) => {
      return !cate.subCategoryList ? (
        <div
          key={cate.groupId}
          className={`cate-item ${chosenCategory === cate ? '-chosen' : ''}`}
          onClick={() => choseCategory(cate)}
        >
          <Checkbox
            key={`checkbox-${cate.groupId}`}
            checked={filter.includes(cate.groupId)}
            onChange={() => filterItem(cate)}
          />
          {cate.categoryName}
        </div>
      ) : (
        <div key={cate.groupId}>
          <div
            className={`cate-item ${chosenCategory === cate ? '-chosen' : ''} ${
              chosenSubCategory?.groupId.includes(cate.groupId) ? '_chosen-sub-cate' : ''
            }`}
            onClick={() => choseCategory(cate)}
          >
            <Checkbox
              key={`checkbox-${cate.groupId}`}
              checked={filter.includes(cate.groupId)}
              onChange={() => filterItem(cate)}
              indeterminate={
                (filter.includes(cate.groupId) &&
                  filter.filter((i) => i.startsWith(cate.groupId)).length - 1 !== cate.subCategoryList.length) ||
                (!filter.includes(cate.groupId) && filter.some((i) => i.startsWith(cate.groupId)))
              }
            />
            <div className={`collapse`}>
              <span>{cate.categoryName}</span>
              <CaretRightOutlined rotate={chosenCategory === cate && dropdown ? 90 : 0} />
            </div>
          </div>
          <div className={`expand`}>
            {dropdown && chosenCategory === cate && cate.subCategoryList.length
              ? cate.subCategoryList.map((subCate) => (
                  <div
                    key={subCate.groupId}
                    className={`sub-cate-item ${chosenSubCategory === subCate ? '-chosen' : ''}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      choseSubCategory(subCate);
                      const el = document.getElementById(subCate.groupId);
                      el?.scrollIntoView({ behavior: 'smooth' });
                    }}
                  >
                    <Checkbox
                      key={`checkbox-${subCate.groupId}`}
                      checked={filter.includes(subCate.groupId)}
                      onChange={() => filterItem(cate, subCate)}
                    />
                    {subCate.subCategoryName}
                  </div>
                ))
              : ''}
          </div>
        </div>
      );
    });

  const renderComponents = () => {
    if (!chosenCategory) return;
    if (chosenCategory.subCategoryList) {
      return chosenCategory.subCategoryList.map((subCate) => (
        <div key={subCate.groupId} id={subCate.groupId}>
          <span className="title">{subCate.subCategoryName}</span>
          <div className={'components-container'}>
            {subCate.componentList.map((i) => (
              <Element key={i.id} item={i} displayName={false} withToolTip={false} />
            ))}
          </div>
        </div>
      ));
    } else {
      return (
        <div>
          <span className="title">{chosenCategory.categoryName}</span>
          <div key={chosenCategory.groupId} className={'components-container'}>
            {chosenCategory.componentList.map((i) => (
              <Element key={i.id} item={i} displayName={false} withToolTip={false} />
            ))}
          </div>
        </div>
      );
    }
  };

  useEffect(() => {
    setChosenCategory(categories[0]);
  }, []);

  useEffect(() => {
    setFilter(filterList);
  }, [filterList]);

  return (
    <>
      <Modal
        width={700}
        destroyOnClose
        open={visible}
        title="Filter components"
        onCancel={onClose}
        footer={[
          <Button key="back" type="default" onClick={onClose}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={onSave}>
            Save
          </Button>,
        ]}
      >
        <div className="filter-modal">
          <div className="category">
            <div className="cate-title">{componentObj.text}</div>
            <div className="cate-content">{renderCategory(categories)}</div>
          </div>
          <div className="components">{renderComponents()}</div>
        </div>
      </Modal>
    </>
  );
};

export default FilterComponentModal;
